import React from "react";
import Feature from "./Feature";

function Features() {

  return (
    <div className="py-12 bg-gray-100" data-aos="fade-up">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 my-2">
        <div className="lg:text-center">
          <h3 className="text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
            The ultimate landing page for your project
          </h3>
          <p className="mt-4 max-w-2xl text-xl font-body leading-7 text-gray-800 lg:mx-auto">
            Quickly launch your business with a solid online foundation that will scale as your business grows. 
          </p>
        </div>

        <div className="mt-10">
          <ul className="md:grid md:grid-cols-3 md:col-gap-8 md:row-gap-10">
            {[
              'Lightning Fast',
              'Mobile Responsive',
              'Production Ready',
              'Progressive Web App',
              'Conversion optimized',
              'Form integration',                     
            ].map((item, index) => (
              <li key={index}>
                <Feature
                  featureTitle={item}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Features;